const auth = (state = {}, action) => {
  switch (action.type) {
    case "LOGIN_SUCCESS":
      return { ...state, ...action.data };
    case "USER_LOGOUT":
      return {};
    default:
      return state;
  }
};
export default auth;
